import { Language } from '../language';

export class LanguageEnum {
    public static NL: Language = new Language('nl', 'nl-BE', 'Nederlands');
    public static FR: Language = new Language('fr', 'fr-BE', 'Français');
}



// WEBPACK FOOTER //
// ./src/app/core/models/enums/language-enum.ts